import CustomButton from "components/CustomButton/CustomButton";
import CustomSearchInput from "components/CustomSearchInput/CustomSearchInput";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import { handlerKeyPressOnlyNumbersAndLetters } from "utils/validations";
import {
	Fields,
	AddStudentField,
} from "views/components/AttendanceList/styles";

const AttendanceFields = ({
	studentsFoundList,
	searchedStudent,
	pinStudentReservation,
	changeSearchedStudent,
	eventData,
	studentToAdd,
	searchStudent,
}) => {
	const canSearchStudent = () => {
		const { length } = studentToAdd.value.id;
		return length >= 7 && length <= 9;
	};
	return (
		<Fields>
			<CustomSearchInput
				dataFound={studentsFoundList}
				foundItemText={searchedStudent}
				selectDataItem={({ id }) => pinStudentReservation(id)}
				handlerItemSearched={changeSearchedStudent}
				placeholder="Buscar un alumno en la lista"
				positionFoundBlock="absolute"
			/>
			{/* {eventData.isPresential && (
				<AddStudentField>
					<CustomTextInput
						label="Agrega un alumno al listado"
						variant="secondary"
						placeholder="Añadir el código del alumno"
						value={studentToAdd.value.id}
						maxLength={9}
						onKeyPress={handlerKeyPressOnlyNumbersAndLetters}
						onChange={studentToAdd.changeField}
					/>
					<CustomButton
						size="medium"
						width="120px"
						text="Buscar"
						disabled={!canSearchStudent()}
						onClick={searchStudent}
					/>
				</AddStudentField>
			)} */}
		</Fields>
	);
};

export default AttendanceFields;
